import { render, staticRenderFns } from "./PackagesHistoryTable.vue?vue&type=template&id=309a6756&scoped=true&"
import script from "./PackagesHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PackagesHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./PackagesHistoryTable.vue?vue&type=style&index=0&id=309a6756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a6756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VSelect,VSpacer})
